import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { provideHooks } from 'redial';

import {
  loadProductsPage,
  loadRecommendedProductsForPage,
  openMobileRefineBy,
} from '../actions/catalogue';

import ProductsPageRoute from 'apps/productsPages/utils/ProductsPageRoute';

import AfterLoginFreshener from 'apps/user/containers/AfterLoginFreshener';
import OfferDetailsPageComponent from '../components/OfferDetailsPage';

class OfferDetailsPage extends PureComponent {
  static propTypes = {
    refreshPage: PropTypes.func.isRequired,
  };

  render() {
    const { refreshPage, ...otherProps } = this.props;

    return (
      <Fragment>
        <AfterLoginFreshener refreshPage={refreshPage} />
        <OfferDetailsPageComponent {...otherProps} />
      </Fragment>
    );
  }
}

const fetchHook = ({ dispatch, route }) => dispatch(loadProductsPage(route));

const deferHook = ({ dispatch, route }) => {
  dispatch(loadRecommendedProductsForPage(route));
};

export default provideHooks({
  fetch: ({ location, params, dispatch }) => {
    const route = new ProductsPageRoute(location, params);
    return fetchHook({ dispatch, route });
  },
  defer: ({ location, params, dispatch }) => {
    const route = new ProductsPageRoute(location, params);
    deferHook({ dispatch, route });
  },
})(connect(
  (state, ownProps) => {
    const productsPageRoute = new ProductsPageRoute(ownProps.location, ownProps.params);
    const routeString = productsPageRoute.toString();
    const { basePath } = productsPageRoute;
    return {
      basePath,
      routeString,
      productsPage: state.catalogue.productsPagesByRoute[routeString],
      betaFeatures: state.user.betaFeatures,
      fopViewPreference: state.user.fopViewPreference,
    };
  },
  (dispatch, ownProps) => ({
    ...bindActionCreators({ openMobileRefineBy }, dispatch),
    refreshPage() {
      const route = new ProductsPageRoute(ownProps.location, ownProps.params);
      fetchHook({ dispatch, route })
        .then(() => deferHook({ dispatch, route }));
    },
  })
)(OfferDetailsPage));
